'use strict';

angular.module('tcApp')
.directive('tcTextareaSelection', function() {
	return {
		restrict: 'A',
		scope: {
			tcTextareaOnSelection: '='
		},
		link: function(scope, elem) {
			elem.on('select', function() { 
				var text = elem.val().substring(elem.prop('selectionStart'), elem.prop('selectionEnd'));
				scope.tcTextareaOnSelection(text, elem[0].id); 
			});
			
			elem.on('blur', function(e) {
				var target = e.relatedTarget;
				if (target && target.id) {
					var match = /AddCannedTextLink$/.test(target.id);
					if (!match) {
						scope.tcTextareaOnSelection('', null);
					}
				} else {
					scope.tcTextareaOnSelection('', null);
				}
			});
			
			elem.on('keydown', function() { 
				scope.tcTextareaOnSelection('', null);
			});
			elem.on('mousedown', function() { 
				scope.tcTextareaOnSelection('', null);
			});
		}
	};
});
